import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./i18n";
import { Provider } from "react-redux";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { PersistGate } from "redux-persist/integration/react";
import { persistor, store } from "./appStore/store";
import { BrowserRouter } from "react-router-dom";
import theme from "./theme";
import { logWrapper } from "./utils/helper";
import { initVersionCheck } from "./utils/versionCheck";

// Detect new deployments and prompt connected clients to refresh + purge stale state
initVersionCheck();

// Service Worker Registration
if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .register("/firebase-messaging-sw.js", { scope: "/" })
    .then((registration) => {
      // logWrapper('Service Worker registered with scope:', registration.scope);
    })
    .catch((error) => {
      // logWrapper('Service Worker registration failed:', error);
    });
}

// Global error handlers
const logError = (message, source, lineno, colno, error) => {
  // console.error("Global error captured:", {
  //   message,
  //   source,
  //   lineno,
  //   colno,
  //   error,
  // });
  // You can send the error to a server for logging here
};

window.onerror = function (message, source, lineno, colno, error) {
  logError(message, source, lineno, colno, error);
  return true;
};

window.onunhandledrejection = function (event) {
  logError("Unhandled promise rejection", null, null, null, event.reason);
  return true;
};

// Create the persistor
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Provider store={store}>
        <PersistGate persistor={persistor}>
          <BrowserRouter>
            <>
              <App />
            </>
          </BrowserRouter>
        </PersistGate>
      </Provider>
    </ThemeProvider>
  </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
